import ptBR from 'date-fns/locale/pt-BR';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { isMobile } from 'react-device-detect';
import { HiDownload } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import {
  oSStatusOptions,
  statusBadges,
  statusOptions,
} from '../../screens/ModalBudget/utils/constants';
import { supabase } from '../../supabaseClient';
import { SelectInput } from '../Input/Input';
import { useDebounce } from '../../core/hooks/useDebounce';

const CustomHeader = ({
  filter,
  setFilter,
  showConsultantFilter = false,
  isOS = false,
  statusOptions: customStatusOptions = null,
  onDownloadReport = null,
  isDownloadingReport = false,
  hasReportData = true,
}) => {
  const [startDate, endDate] = filter.dates || [null, null];
  const [consultants, setConsultants] = useState([]);
  const [searchInput, setSearchInput] = useState(filter?.search || "");
  const debouncedSearch = useDebounce(searchInput, 500);

  const company = useSelector(
    (state) => state.app.company || { id: -1, name: 'Prospera' }
  );

  const loadConsultants = async (id) => {
    const { data, error } = await supabase
      .from('CompanyConsultant')
      .select('id, name')
      .eq('company_id', id)
      .is('deleted_at', null);
    if (!error) {
      setConsultants(data);
    }
  };

  useEffect(() => {
    loadConsultants(company.id);
  }, [company.id]);

  // Update filter only when debounced value changes
  useEffect(() => {
    setFilter((filter) => ({ ...filter, search: debouncedSearch }));
  }, [debouncedSearch]);

  // Sync local state if filter.search changes externally
  useEffect(() => {
    if (filter?.search !== searchInput) {
      setSearchInput(filter?.search || "");
    }
  }, [filter?.search]);

  return (
    <div className="header-mobile">
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div
          style={{
            display: 'flex',
            width: '100%',
            paddingRight: '10px',
            maxWidth: 500,
          }}
        >
          {isMobile ? (
            <span className="rgt-search-icon custom-header-icon">⚲</span>
          ) : (
            <label className="rgt-search-label" htmlFor="rgt-search">
              <span className="rgt-search-icon custom-header-icon">⚲</span>
              Buscar:
            </label>
          )}
          <input
            className="rgt-search-input custom-header-input"
            type="search"
            placeholder="Digite para Pesquisar"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            style={{
              backgroundColor: '#D9DBE9',
              color: 'black',
            }}
          />
        </div>
        {!isMobile && (
          <div style={{ display: 'flex', width: '70%', flexDirection: 'row' }}>
            <DatePicker
              dateFormat="dd/MM/yyyy"
              locale={ptBR}
              selectsRange={true}
              shouldCloseOnSelect={true}
              startDate={startDate}
              endDate={endDate}
              onChange={(dates) => {
                setFilter((filter) => ({ ...filter, dates }));
              }}
              isClearable={true}
              placeholderText="Filtrar período"
            />
            {showConsultantFilter && (
              <div className="custom-header-select">
                <SelectInput
                  isClearable={true}
                  placeholder={'Filtre o consultor'}
                  onChange={(value) =>
                    setFilter((filter) => ({
                      ...filter,
                      consultant: value?.id ?? null,
                    }))
                  }
                  options={consultants?.map((o) => ({
                    id: o.id,
                    value: o.id,
                    label: o.name?.toUpperCase(),
                  }))}
                />
              </div>
            )}
            <div className="custom-header-select">
              <SelectInput
                isClearable={true}
                placeholder={'Filtre o status'}
                onChange={(value) =>
                  setFilter((filter) => ({ ...filter, status: value }))
                }
                options={customStatusOptions || (isOS ? oSStatusOptions : statusOptions)}
              />
            </div>
            {onDownloadReport && (
              <button
                className="download-report-btn"
                onClick={onDownloadReport}
                disabled={isDownloadingReport || !hasReportData}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  padding: '0 16px',
                  height: '32px',
                  minHeight: '32px',
                  backgroundColor: '#70e000',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '13px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  marginLeft: '10px',
                  whiteSpace: 'nowrap',
                }}
              >
                <HiDownload style={{ fontSize: '16px' }} />
                <span>{isDownloadingReport ? 'Gerando...' : 'Baixar'}</span>
              </button>
            )}
          </div>
        )}
      </div>
      {isMobile && (
        <div style={{ display: 'flex', width: '100%', flexDirection: 'row', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
          <DatePicker
            dateFormat="dd/MM/yyyy"
            locale={ptBR}
            selectsRange={true}
            shouldCloseOnSelect={true}
            startDate={startDate}
            endDate={endDate}
            onChange={(dates) => {
              setFilter((filter) => ({ ...filter, dates }));
            }}
            isClearable={true}
            placeholderText="Filtrar período"
          />
          {showConsultantFilter && (
            <div className="custom-header-select">
              <SelectInput
                isClearable={true}
                placeholder={'Filtre o consultor'}
                onChange={(value) =>
                  setFilter((filter) => ({
                    ...filter,
                    consultant: value?.id ?? null,
                  }))
                }
                options={consultants?.map((o) => ({
                  id: o.id,
                  value: o.id,
                  label: o.name?.toUpperCase(),
                }))}
              />
            </div>
          )}
          <div className="custom-header-select">
            <SelectInput
              isClearable={true}
              placeholder={'Filtre o status'}
              onChange={(value) =>
                setFilter((filter) => ({ ...filter, status: value }))
              }
              options={customStatusOptions || (isOS ? oSStatusOptions : statusOptions)}
            />
          </div>
          {onDownloadReport && (
            <button
              className="download-report-btn"
              onClick={onDownloadReport}
              disabled={isDownloadingReport || !hasReportData}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '0 16px',
                height: '32px',
                minHeight: '32px',
                backgroundColor: '#70e000',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                fontSize: '13px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap',
                width: '100%',
              }}
            >
              <HiDownload style={{ fontSize: '16px' }} />
              <span>{isDownloadingReport ? 'Gerando...' : 'Baixar'}</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomHeader;
